import { Select, Spin } from "antd";
import React, { useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../../../api/request.tsx";
import { toast } from "react-toastify";
import apiClient from "../../../api/axiosConfig.tsx";
import { LoadingOutlined } from "@ant-design/icons";

const CreateAccountCoupon = () => {
  const [data, setData] = React.useState<any>({
    email: "",
    password: "",
    branh_resgisted: "",
    name: "",
  });
  const [emailError, setEmailError] = React.useState<string>("");
  const [listBranch, setListBranch] = React.useState<any>([]);
  const [branhId, setBranhId] = React.useState<any>(null);
  const [loading, setLoading] = React.useState<boolean>(false);

  const validateEmail = (email: string) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  useEffect(() => {
    (async () => {
      const res = await apiClient.get(
        `branch/get-list-branch?limit=100?page=1`
      );

      if (res?.status == 200) {
        const convertData = res?.data?.data?.results?.map((item: any) => {
          return {
            label: item?.name,
            value: item?.id,
          };
        });
        if (convertData) {
          setListBranch(convertData);
        }
      } else {
        alert("Lỗi không lấy được danh sách chi nhánh");
      }
    })();
  }, []);

  const handleCreateAccount = async () => {
    if (!data.email || !data.password || !data.branh_resgisted || !data.name) {
      alert("Vui lòng nhập đầy đủ thông tin");
      return;
    } else {
      setLoading(true);
      const res = await apiClient.post(`users/create-staff-account`, {
        ...data,
        branhId: branhId,
        role: "STAFF",
      });
      console.log("res======= ", res);
      if (res?.data?.status) {
        setBranhId(undefined);
        setData({
          email: "",
          password: "",
          branh_resgisted: "",
          name: "",
        });
        setLoading(false);
        setEmailError("");
        toast.success(res?.data?.message || "Tạo tài khoản thành công");
      } else {
        setLoading(false);
        toast.error(res?.data?.message || "Lỗi không tạo được tài khoản");
      }
    }
  };

  const classInput =
    "w-full border-[1px] border-[pink] rounded-md px-2 py-2 outline-none";
  const classLable = "md:font-semibold w-full text-[pink]";

  return (
    <div className="w-full">
      <div className="text-2xl text-center text-[pink] font-bold">
        TẠO TÀI KHOẢN COUPON
      </div>
      <div className="text-sm text-center text-red-300 md:font-bold">
        Vui lòng tạo thông tin chi nhánh trước khi khi tạo tài khoản coupon
      </div>
      <div className="mb-3">
        <div className={classLable}>Email</div>
        <input
          onChange={(value) => {
            setData({
              ...data,
              email: value.target.value,
            });
          }}
          value={data.email}
          type="text"
          className={classInput}
        />
        {emailError && (
          <div className="text-red-500 text-sm mt-1">{emailError}</div>
        )}
      </div>
      <div className="mb-3">
        <div className={classLable}>Mật khẩu</div>
        <input
          onChange={(value) => {
            setData({
              ...data,
              password: value.target.value,
            });
          }}
          value={data.password}
          type="text"
          className={classInput}
        />
      </div>
      <div className="mb-3">
        <div className={classLable}>
          Mã chi nhánh (Ví dụ: BA_RIA, LOTTE_DN...)
        </div>
        <input
          onChange={(value) => {
            setData({
              ...data,
              branh_resgisted: value.target.value,
            });
          }}
          value={data.branh_resgisted}
          type="text"
          className={classInput}
        />
      </div>
      <div className="mb-3">
        <div className={classLable}>
          Tên chi nhánh (Ví dụ: Chi nhánh Bà Rịa...)
        </div>
        <input
          onChange={(value) => {
            setData({
              ...data,
              name: value.target.value,
            });
          }}
          value={data.name}
          type="text"
          className={classInput}
        />
      </div>
      <div className="mb-3">
        <div className={classLable}>Lựa chọn chi nhánh</div>
        {listBranch && (
          <Select
            onChange={(e) => {
              setBranhId(e);
            }}
            size="large"
            className="custom-select w-full text-[pink] border-[pink] rounded-md"
          >
            {listBranch?.map((item: any) => {
              return (
                <Select.Option key={item?.value} value={item?.value}>
                  {item?.label}
                </Select.Option>
              );
            })}
          </Select>
        )}
      </div>
      <div className="flex justify-center">
        <button
          className="mb-4 bg-[pink] text-white py-3 px-6 rounded-md"
          onClick={() => {
            if (!validateEmail(data.email)) {
              setEmailError("Email không hợp lệ");
              return;
            }
            if (!branhId) {
              alert("Vui lòng chọn chi nhánh");
              return;
            }
            setEmailError(""); // Xóa lỗi nếu đúng
            handleCreateAccount();
          }}
        >
          {loading ? (
            <Spin
              className="text-white"
              indicator={<LoadingOutlined color="white" spin />}
              size="small"
            />
          ) : (
            "Tạo mới"
          )}
        </button>
      </div>
    </div>
  );
};

export default CreateAccountCoupon;
